import React, { useMemo } from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import { WalkerSectionContainer } from '../WalkerServices/WalkerCollapsible/WalkerSectionContainer';
import { WalkerAchievementsResponse, WalkerHomeInfo, WalkerHomePhotos, WalkerProfileV6, WalkerSpecialtiesV6 } from '../../../../types/api';
import { WalkerSpecialty } from '../WalkerServices/WalkerCollapsible/WalkerSpecialties';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type Props = {
  containerProps?: BoxProps;
  profile: WalkerProfileV6;
  specialties: WalkerSpecialtiesV6;
  homePhotos: WalkerHomePhotos;
  homeInfo: WalkerHomeInfo;
  achievements: WalkerAchievementsResponse;
};
export const WalkerAbout = ({
  containerProps,
  profile,
  specialties,
  homePhotos,
  homeInfo,
  achievements
}: Props) => {
  const reducedAchievements = useMemo(() => {
    const savedAchievements: WalkerAchievementsResponse['items'] = [];
    if (achievements?.items?.length) {
      achievements.items.forEach(achievement => {
        const findAchievement = savedAchievements.find(savedAchievement => savedAchievement.name === achievement.name);
        if (!findAchievement) {
          savedAchievements.push(achievement);
        }
      });
    }
    return {
      ...achievements,
      items: savedAchievements
    };
  }, [achievements]);
  return <Box {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerAbout" data-sentry-source-file="index.tsx">
      <WalkerSectionContainer title="About the caregiver" text={profile.bio} containerProps={{
      pt: 0
    }} data-sentry-element="WalkerSectionContainer" data-sentry-source-file="index.tsx" />

      {specialties?.flags?.length ? <WalkerSectionContainer title="Specialties">
          {specialties.flags.map(specialty => specialty.selected && <WalkerSpecialty key={specialty.slug} containerProps={{
        width: ['100%', '50%']
      }} label={specialty.slug} />)}
        </WalkerSectionContainer> : null}

      {homeInfo?.flags?.length ? <WalkerSectionContainer title="Caregivers Home" text={homeInfo?.description}>
          {homeInfo.flags.map(homeInfoFlag => homeInfoFlag.selected && <WalkerSpecialty key={homeInfoFlag.slug} containerProps={{
        width: ['100%', '50%']
      }} label={homeInfoFlag.slug} />)}
        </WalkerSectionContainer> : null}

      {homePhotos?.items?.length ? <WalkerSectionContainer title="Where they will be staying" containerProps={{
      width: ['100vw', '100%']
    }}>
          <Box display={['block', 'flex']} flexWrap={['nowrap', 'wrap']} justifyContent="space-between" overflowX="scroll" width="100%" style={{
        whiteSpace: 'nowrap'
      }}>
            {homePhotos.items.map((item, key) => <Image key={item.url} src={item.url} display="inline-block" width={['300px']} height={['150px']} mr={[2, 0]} alt={`caregiver home photo ${key}`} objectFit="cover" overflow="hidden" borderRadius="12px" mb={2} style={{
          objectFit: 'cover'
        }} loading="lazy" />)}
          </Box>
        </WalkerSectionContainer> : null}

      {reducedAchievements?.items?.length ? <WalkerSectionContainer title="Achievements" containerProps={{
      justifyContent: 'flex-start'
    }}>
          {reducedAchievements?.items.map(achievement => <Box key={achievement.name} display="flex" flexDirection="column" alignItems="center" mr={3} width="70px">
              <Image src={achievement?.iconUrl} width="58px" height="58px" alt="achievement icon" />
              <Typography color="#272727" variant="body1" fontFamily="muliBold" fontSize="12px" m={0} pt={1} textAlign="center">
                {achievement.name}
              </Typography>
            </Box>)}
        </WalkerSectionContainer> : null}
    </Box>;
};